import { Component } from '@angular/core';

@Component({
  selector: 'app-home-redesign',
  templateUrl: './home-redesign.component.html',
  styleUrls: ['./home-redesign.component.scss']
})
export class HomeRedesignComponent {

}
